import React from "react";
import { IconProps, iconPropTypes } from "./IconProps";

const CaretRightIcon: React.FC<IconProps> = ({
  fill = "",
  width = 32,
  height = 32,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M22.7075 16.7076L12.7075 26.7076C12.6146 26.8005 12.5043 26.8742 12.3829 26.9245C12.2615 26.9747 12.1314 27.0006 12 27.0006C11.8686 27.0006 11.7385 26.9747 11.6171 26.9245C11.4957 26.8742 11.3854 26.8005 11.2925 26.7076C11.1996 26.6147 11.1259 26.5044 11.0756 26.383C11.0253 26.2616 10.9995 26.1315 10.9995 26.0001C10.9995 25.8687 11.0253 25.7386 11.0756 25.6172C11.1259 25.4958 11.1996 25.3855 11.2925 25.2926L20.5863 16.0001L11.2925 6.70757C11.1049 6.51993 10.9995 6.26543 10.9995 6.00007C10.9995 5.7347 11.1049 5.48021 11.2925 5.29257C11.4801 5.10493 11.7346 4.99951 12 4.99951C12.2654 4.99951 12.5199 5.10493 12.7075 5.29257L22.7075 15.2926C22.8005 15.3854 22.8742 15.4957 22.9246 15.6171C22.9749 15.7385 23.0008 15.8687 23.0008 16.0001C23.0008 16.1315 22.9749 16.2616 22.9246 16.383C22.8742 16.5044 22.8005 16.6147 22.7075 16.7076Z" />
  </svg>
);

CaretRightIcon.propTypes = iconPropTypes;

export default CaretRightIcon;
